import { COUNTDOWN_SET } from '../actions/countdown';
import { ROUND_SELECT } from '../actions/round';
import { HEAT_SELECT } from '../actions/heat';
import { CONTESTS_SHOW_SUCCESS } from '../actions/contests';
import oget from 'oget';

const defaultState = {
  lastUpdated: null,
  timeLeft: null,
};

export default (state = defaultState, { type, payload = {} }) => {
  switch (type) {
    case COUNTDOWN_SET: {
      return {
        ...state,
        timeLeft: payload >= 0 ? payload : 0,
      };
    }

    case ROUND_SELECT: {
      const currentTime = oget(payload.round, 'heats[0].currentTime', null);

      return {
        lastUpdated: currentTime,
        timeLeft: currentTime,
      };
    }

    case HEAT_SELECT: {
      const currentTime = oget(payload, 'currentTime', null);

      return {
        lastUpdated: currentTime,
        timeLeft: currentTime,
      };
    }

    case CONTESTS_SHOW_SUCCESS: {
      const { selectedRound } = payload;

      const currentTime = oget(selectedRound, 'heats[0].currentTime', null);

      if (currentTime === state.lastUpdated) {
        return state;
      }

      return {
        lastUpdated: currentTime,
        timeLeft: currentTime,
      };
    }

    default: {
      return state;
    }
  }
};
